var React = require('react');

function DownloadIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"primary-fill","d":"M19492.5,18121.662l6.5-4.078,6.5,4.078-6.5,4.074Zm6.5-5.434,6.5-4.078,6.5,4.078-6.5,4.072Zm-13,0,6.5-4.078,6.5,4.078-6.5,4.072Zm13-8.154,6.5-4.074,6.5,4.074-6.5,4.076Zm-13,0,6.5-4.074,6.5,4.074-6.5,4.076Z","transform":"translate(-19486 -18104)"}));
}

DownloadIcon.defaultProps = {"width":"26","height":"21.736","viewBox":"0 0 26 21.736"};

module.exports = DownloadIcon;

DownloadIcon.default = DownloadIcon;
